module.exports = __webpack_public_path__ + "static/media/logo.6ede6540.png";